var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagsDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 45,
    viewBox: "0 0 38 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 44,
    rx: 7.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6871 17.3901C24.5164 17.2667 23.3457 17.174 22.1678 17.1046V17.0969L22.0078 16.0935C21.8988 15.3835 21.7388 14.3184 20.0373 14.3184H18.1323C16.4381 14.3184 16.2781 15.3371 16.1617 16.0858L16.009 17.0737C15.3328 17.12 14.6566 17.1663 13.9804 17.2358L12.497 17.3901C12.1917 17.421 11.9735 17.7066 12.0026 18.023C12.0317 18.3395 12.2934 18.571 12.5988 18.5401L14.0822 18.3858C17.8923 17.9844 21.7315 18.1388 25.5853 18.5479H25.6435C25.9198 18.5479 26.1597 18.324 26.1888 18.023C26.2106 17.7066 25.9925 17.421 25.6871 17.3901Z",
    fill: "#989898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3488 19.6369C24.1743 19.444 23.9343 19.3359 23.6871 19.3359H14.4963C14.2491 19.3359 14.0019 19.444 13.8346 19.6369C13.6674 19.8299 13.5729 20.0923 13.5874 20.3624L14.0382 28.2812C14.1182 29.4543 14.22 30.9207 16.7577 30.9207H21.4258C23.9634 30.9207 24.0653 29.462 24.1452 28.2812L24.596 20.3702C24.6106 20.0923 24.516 19.8299 24.3488 19.6369ZM20.2987 27.054H17.8774C17.5793 27.054 17.3321 26.7916 17.3321 26.4751C17.3321 26.1587 17.5793 25.8963 17.8774 25.8963H20.2987C20.5968 25.8963 20.8441 26.1587 20.8441 26.4751C20.8441 26.7916 20.5968 27.054 20.2987 27.054ZM20.9095 23.9668H17.2739C16.9758 23.9668 16.7286 23.7044 16.7286 23.3879C16.7286 23.0715 16.9758 22.8091 17.2739 22.8091H20.9095C21.2076 22.8091 21.4548 23.0715 21.4548 23.3879C21.4548 23.7044 21.2076 23.9668 20.9095 23.9668Z",
    fill: "#989898"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 44,
    rx: 7.5,
    stroke: "#D0D5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsDelete);
export default __webpack_public_path__ + "static/media/tagsDelete.8c33a223b46d1c148e4aef49bc9a72e2.svg";
export { ForwardRef as ReactComponent };